import { Component, OnInit,Inject,EventEmitter} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-common-confirmation-dialog',
  templateUrl: './common-confirmation-dialog.component.html',
  styleUrls: ['./common-confirmation-dialog.component.css']
})
export class CommonConfirmationDialogComponent implements OnInit {
  onEmitStatusChange = new EventEmitter();
  details: any = [];
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any) { }

  ngOnInit(): void {
    if(this.dialogData && this.dialogData.confirmation){
      this.details = this.dialogData;
    }
  }

  handleStatusChangeAction(){
    this.onEmitStatusChange.emit();
  }

}
